export class TaxRateShiftsDto {
  public shifts: IShift[];
  public id: number;
  public name: string;
}

export interface IShift {
  from: number;
  to: number;
}
